import {i18nPathToBundleMap, i18nPreferred} from 'next.config.i18n';

// Falls back to preferred locale or 'en_US' if the locale is not found or undefined.
export function getOgLocale(locale: string | undefined): string {
    if (!locale) return i18nPreferred.at(0) ?? 'en_US';

    return (
        i18nPathToBundleMap[locale as keyof typeof i18nPathToBundleMap] ??
        i18nPreferred.at(0) ??
        'en_US'
    );
}
